import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import 'react-table/react-table.css';
import {
    getClientGMs, getRegionType, getClientGroupType, getModuleType,
    setInitialState, setRowInReducer, deleteClientGM
} from '../../../actions/control_panel/ClientGroupModuleActions';
import i18n from '../../../i18n/i18n';
import Select from 'react-select';
import immutable from 'seamless-immutable';
import { Fab } from '@material-ui/core';
import AddClientGroupModules from './AddClientGroupModules';
import { Delete } from '../../../utils/Delete';
const CheckboxTable = checkboxHOC(ReactTable);;

export class ViewClientGroupModules extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showFilters: false,
            add: false,
            selection: [],
            selectAll: false,
            edit: false,
            delete: false,
        };
        this.tableScrollTop = 0;
    }

    componentDidMount() {
        if (this.props.regionType.length == 0) {
            this.props.getRegionType();
        }
        if (this.props.clientGroupType.length == 0) {
            this.props.getClientGroupType();
        }
        if (this.props.moduleType.length == 0) {
            this.props.getModuleType();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.deleted === true) {
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getClientGMs(wrapped.state);
            this.setState({
                selection: [],
                selectAll: false,
            })
            this.props.setInitialState('clientGMObj');
            this.props.setInitialState('deleted');
        }
        if (nextProps.clientGMPostingSuccess === true) {
            this.setState({
                selection: [],
                name: '',
                selectAll: false
            })
            this.handleClick();
            const wrapped = this.checkboxTable.getWrappedInstance();
            this.props.getClientGMs(wrapped.state);
            this.props.setInitialState('clientGMPostingSuccess');
        }

        this.setState({
            clientGM: nextProps.clientGM,
            clientGMFetching: nextProps.clientGMFetching,

            regionType: immutable.asMutable(nextProps.regionType.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            regionTypeFetching: nextProps.regionTypeFetching,
            regionTypeFetchingFailed: nextProps.regionTypeFetchingFailed,

            clientGroupType: immutable.asMutable(nextProps.clientGroupType.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            clientGroupTypeFetching: nextProps.clientGroupTypeFetching,
            clientGroupTypeFetchingFailed: nextProps.clientGroupTypeFetchingFailed,

            moduleType: immutable.asMutable(nextProps.moduleType.map((item) => { return { label: item.naziv, value: item.id } }), { deep: true }),
            moduleTypeFetching: nextProps.moduleTypeFetching,
            moduleTypeFetchingFailed: nextProps.moduleTypeFetchingFailed,
        })
    }

    onSearchClick() {
        this.setState({ showFilters: !this.state.showFilters });
    }

    onExportClick = () => {
        this.setState({ export: !this.state.export });
    }

    handleClick = () => {
        if (this.state.edit == true && this.state.add == false) {
            this.setState({ edit: false })
            this.props.setInitialState('clientGMObj');
        } else if (this.state.selection.length > 0 && this.state.add == false && this.state.edit == false) {
            this.props.setInitialState('clientGMObj');
        }
        this.setState({ add: !this.state.add }, () => {
            if (this.state.add == true && this.state.edit == false) {
                this.setState({
                    selection: [],
                    name: '',
                    selectAll: false,
                })
            }
        });
    };

    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) {
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
            this.props.setInitialState('clientGMObj');
        } else {
            selection.push(key);
        }
        this.setState({ selection }, function () {
            if (selection.length == 1) {
                let row1 = this.props.clientGM.filter((clGM) => {
                    return clGM.id == selection;
                })
                this.props.setRowInReducer(row1[0], 'clientGMObj');
            }
        });
    };

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => {
                selection.push(item._original.id);
            });
        }
        this.setState({ selectAll, selection });
    };

    isSelected = key => {
        return this.state.selection.includes(key);
    };

    onDeleteClick = () => {
        this.setState({ delete: !this.state.delete });
    }

    deleteItem = () => {
        this.props.deleteClientGM(this.state.selection);
        this.setState({ delete: false })
    }

    onEditClick() {
        this.setState({ add: !this.state.add, edit: true });
    }

    onTableClick = () => {
        this.props.history.push('/client_gm');
    }


    render() {
        const columns = [
            {
                Header: i18n.t('ID'),
                accessor: 'id'
            },

            {
                Header: i18n.t('Klijent grupa'),
                accessor: 'naziv_klijent_grupe',
                Filter: ({ filter, onChange }) =>
                    <Select
                        isMulti
                        name="naziv"
                        onChange={value => {
                            onChange(value)
                        }}
                        closeMenuOnSelect={false}
                        options={this.state.clientGroupType}
                        className="multi-select-in-filter"
                        classNamePrefix="select"
                        placeholder={i18n.t('Select')}
                    />
            },
            {
                Header: i18n.t('Modul'),
                accessor: 'naziv_modula',
                Filter: ({ filter, onChange }) =>
                    <Select
                        isMulti
                        name="naziv"
                        onChange={value => {
                            onChange(value)
                        }}
                        closeMenuOnSelect={false}
                        options={this.state.moduleType}
                        className="multi-select-in-filter"
                        classNamePrefix="select"
                        placeholder={i18n.t('Select')}
                    />
            },
            {
                Header: i18n.t('Region'),
                accessor: 'naziv_regiona',
                Filter: ({ filter, onChange }) =>
                    <Select
                        isMulti
                        name="naziv"
                        onChange={value => {
                            onChange(value)
                        }}
                        closeMenuOnSelect={false}
                        options={this.state.regionType}
                        className="multi-select-in-filter"
                        classNamePrefix="select"
                        placeholder={i18n.t('Select')}
                    />
            },
            {
                id: 'aktivan',
                Header: i18n.t('Aktivan'),
                accessor: d => d.pravi, // Custom value accessors!
                Cell: ({ value }) => value != 0 ? i18n.t('Yes') : i18n.t('No')
            },
        ];

        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll } = this.state;
        const checkboxProps = {
            selectAll,
            isSelected,
            toggleSelection,
            toggleAll,
            selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return {
                        style: {
                            backgroundColor: selected ? "lightgreen" : "inherit"
                        }
                    };
                }
                return {};
            }
        };
        return (
            <div className="page">
                <div className="table-header">
                    <Fab onClick={() => this.handleClick()}
                        color="primary"
                        aria-label="add"
                        className="action-button">
                        <span className="icon-Plus headerIcon" />
                    </Fab>
                    <Fab onClick={() => this.onSearchClick()}
                        color="primary"
                        aria-label="add"
                        className="action-button"    >
                        <span className="icon-search headerIcon" />
                    </Fab>

                    {this.state.selection.length > 0 ?
                        <Fab onClick={() => this.onDeleteClick()}
                            color="primary"
                            aria-label="add"
                            className="action-button">
                            <span className="icon-Kanta headerIcon" />
                        </Fab>
                        : null
                    }
                    {this.state.selection.length === 1 ?
                            <Fab onClick={() => this.onEditClick()}
                                color="primary"
                                aria-label="edit"
                                className="action-button">
                                <span className="icon-Izmeni1 headerIcon" />
                            </Fab>
                        : null
                    }
                </div>
                <CheckboxTable ref={r => (this.checkboxTable = r)}
                    data={this.props.clientGM}
                    getTheadFilterThProps={() => { return { style: { position: "inherit", overflow: "inherit" } } }}
                    columns={columns}
                    keyField={'id'}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={this.state.showFilters}
                    pages={this.props.clientGMPages}
                    loading={this.props.clientGMFetching}
                    manual
                    showPaginationTop
                    showPaginationBottom={false}
                    onFetchData={(state, instance) => this.props.getClientGMs(state, instance)}
                    className="-striped -highlight"
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps} />

                {this.state.add && <AddClientGroupModules add={this.state.add} edit={this.state.edit} handleClose={this.handleClick} />}
                {this.state.delete && <Delete delete={this.state.delete} handleClose={this.onDeleteClick} deleteItem={this.deleteItem} />}

            </div>
        )
    }
};

function mapStateToProps(state) {
    return {
        clientGM: state.clientGMReducer.clientGM,
        clientGMFetching: state.clientGMReducer.clientGMFetching,
        clientGMPages: state.clientGMReducer.clientGMPages,
        clientGMObj: state.clientGMReducer.clientGMObj,
        clientGMPostingSuccess: state.clientGMReducer.clientGMPostingSuccess,

        deleted: state.clientGMReducer.deleted,

        regionType: state.clientGMReducer.regionType,
        regionTypeFetching: state.clientGMReducer.regionTypeFetching,
        regionTypeFetchingFailed: state.clientGMReducer.regionTypeFetchingFailed,

        clientGroupType: state.clientGMReducer.clientGroupType,
        clientGroupTypeFetching: state.clientGMReducer.clientGroupTypeFetching,
        clientGroupTypeFetchingFailed: state.clientGMReducer.clientGroupTypeFetchingFailed,

        moduleType: state.clientGMReducer.moduleType,
        moduleTypeFetching: state.clientGMReducer.moduleTypeFetching,
        moduleTypeFetchingFailed: state.clientGMReducer.moduleTypeFetchingFailed,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getClientGMs: (state, instance) => dispatch(getClientGMs(state, instance)),

        setInitialState: (component) => dispatch(setInitialState(component)),
        setRowInReducer: (rowInfo) => dispatch(setRowInReducer(rowInfo)),

        deleteClientGM: (selection) => dispatch(deleteClientGM(selection)),

        getRegionType: () => dispatch(getRegionType()),
        getClientGroupType: () => dispatch(getClientGroupType()),
        getModuleType: () => dispatch(getModuleType()),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewClientGroupModules);